import React, { ReactElement, ReactNode } from 'react'
import useTranslation from 'next-translate/useTranslation'
import Auth from '@/components/templates/Auth'
import { socialsLogin } from '@/data/auth'
import NoFooterLayout from '@/components/layouts/NoFooterLayout'
import CustomHead from '@/components/molecules/CustomHead'

export default function Login() {
  const { t } = useTranslation('common')
  const metaData = {
    title: t('common:login_to_bulldog'),
    noindex: true,
  }

  return (
    <>
      <CustomHead metaData={metaData} />
      <Auth
        data={socialsLogin.map((item) => ({
          ...item,
          title: t(`common:${item.title}`),
        }))}
        title={t('common:welcome_back')}
      />
    </>
  )
}

Login.getLayout = function getLayout(page: ReactElement) {
  return <NoFooterLayout>{page}</NoFooterLayout>
}
